class CteOperations {
    constructor(modal, attrs) {
        this.modal = modal
        this.hasVoltar = !!attrs.onVoltar
    }

    openImportModal() {
        this.modal.open({
            backdrop: 'static',
            component: 'cteUploadXmlModal',
            resolve: {
                contratoId: () => this.contratoId
            }
        })
    }
}

angular.module('eficienciaFiscalModule')
    .component('cteOperations', {
        controller: ['$uibModal', '$attrs', CteOperations],
        bindings: {
            onVoltar: '&',
            disabled: '<',
            contratoId: '<'
        },
        template: `
        <operations-toolbar>
            <left ng-if="$ctrl.hasVoltar">
                <button class="btn btn-default" ng-click="$ctrl.onVoltar()">
                    <i class="fa fa-arrow-left"></i> Voltar
                </button>
            </left>
            <right>
                <button
                    class="btn btn-default"
                    ng-click="$ctrl.openImportModal()"
                    ng-disabled="$ctrl.disabled">
                    <i class="fa fa-upload"></i> Enviar XML
                </button>
            </right>
        </operations-toolbar>
        `
    })
